<template>
  <div class="dialog-box">
    <div class="dialog" v-if="!error">
      <h3 class="dialog__title">Вход</h3>
      <p class="dialog__text">Введите email и пароль, используемые в приложении “Планета Вита”.</p>
      <form class="dialog__form" @submit="login($event, user)">
        <vita-input placeholder="Логин" type="mail" icon="mail" v-model="user.login"
                    data-qa="auth-dialog-test-input-login"/>
        <vita-input placeholder="Пароль" type="password" icon="password" v-model="user.password" :error="error"
                    data-qa="auth-dialog-test-input-password"/>
        <div class="dialog__links">
          <a :class="{disabled: inProcess}" @click="changePassword"
             data-qa="auth-dialog-test-link-restore-password">Восстановить пароль</a>
          <div style="height: 18px"></div>
        </div>
        <vita-button :disabled="inProcess" data-qa="auth-dialog-test-button-login">Войти</vita-button>
      </form>
    </div>
    <authentication-error :error="error" @click-link="changePassword" v-else />
    <div class="dialog__tooltip">
      <vita-tooltip :open="tooltip.open" @closed="closeTooltip" :title="tooltip.title" :text="tooltip.text"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import AuthenticationError from "@/components/AuthenticationError.vue"
import {computed, ref} from "vue"
import {useStore} from "vuex";
import router from '@/router';
import { isUserAuthenticated } from '@/utils/user';

interface TooltipOptions {
  title: string,
  text: string,
  open: boolean
}

interface User {
  login: string,
  password: string
}

const store = useStore()
const inProcess = ref(false);

const tooltip = ref<TooltipOptions>({
  title: '',
  text: '',
  open: false
})

const user = ref<User>({
  login: '',
  password: ''
})

const error = computed(() => {
  return store.getters['user/loginError']
})

const login = async (e: Event, user: User) => {
  e.preventDefault()
  try {
    inProcess.value = true
    if (!user.password.length) {
      store.commit('user/setError', 'Введите пароль')
      return
    }
    if (!user.login.length) {
      store.commit('user/setError', 'Введите логин')
      return
    }
    closeTooltip()
    await store.dispatch('user/loginTest', user)
  } catch (error) {
    console.error(error)
  } finally {
    inProcess.value = false
  }
}

const closeTooltip = () => {
  tooltip.value.open = false
  tooltip.value.title = ''
  tooltip.value.text = ''
}

const changePassword = () => {
  router.push('/reset-pass')
}

// Редирект со страницы авторизации если пользователь авторизован
if (!window.location.host.startsWith('localhost') && isUserAuthenticated()) {
  router.push("/");
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use '../static/style/variables.scss' as *;

.dialog-box {
  position: relative;
}

.dialog {
  padding: 20px 24px;
  max-width: 376px;
  text-align: center;
  background: $white;
  box-shadow: -1px 0px 12px 0px #00000026;
  border-radius: 3px;
  position: relative;

  &__title {
    font-size: 22px;
    font-weight: 600;
    line-height: 27px;
    margin-bottom: 49px;
  }

  &__text {
    margin-bottom: 20px;
  }

  &__links {
    margin: 48px 0;
    position: relative;
    font-size: 13px;

    a {
      display: block;
      margin-bottom: 20px;
      color: $blue;
      font-weight: 500;
      cursor: pointer;
    }
  }

  &__tooltip {
    position: absolute;
    top: calc(100% + 45px);
    left: 50%;
    transform: translateX(-50%);
  }
}

a.disabled {
  pointer-events: none;
  cursor: default;
  color: rgba(136, 136, 136, 0.5);
}
</style>
